// src/components/common/LazyHeroImage.js
import React, { useState, useEffect } from 'react';
import './LazyHeroImage.css';

export default function LazyHeroImage({
  srcMobile,
  srcTablet,
  srcDesktop,
  blurSrc,
  alt = '',
  className = '',
  fetchpriority = 'high'
}) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [currentSrc, setCurrentSrc] = useState(blurSrc);

  useEffect(() => {
    // Start loading immediately
    setIsLoaded(false);
    
    const updateImage = () => {
      const width = window.innerWidth;
      let targetSrc;

      // Responsive Breakpoints
      if (width <= 768) {
        targetSrc = srcMobile;
      } else if (width <= 1280) {
        targetSrc = srcTablet;
      } else {
        targetSrc = srcDesktop;
      }

      console.log(`[LazyHeroImage] Loading for width ${width}px:`, targetSrc);

      // Preload image
      const img = new Image();
      img.onload = () => {
        console.log(`[LazyHeroImage] ✅ Loaded:`, targetSrc);
        setCurrentSrc(targetSrc);
        setIsLoaded(true);
      };
      img.onerror = (error) => {
        console.error(`[LazyHeroImage] ❌ Error loading:`, targetSrc, error);
        // Fallback to blur on error
        setIsLoaded(true);
      };
      img.src = targetSrc;
    };

    // Initial load
    updateImage();

    // Debounced resize handler
    let resizeTimer;
    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        updateImage();
      }, 200);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(resizeTimer);
    };
  }, [srcMobile, srcTablet, srcDesktop, blurSrc]);

  return (
    <div className={`lazy-hero-wrapper ${className}`}>
      <img
        src={currentSrc}
        alt={alt}
        className={`lazy-hero-image ${isLoaded ? 'loaded' : 'loading'}`}
        loading="eager"
        fetchpriority={fetchpriority}
        decoding="async"
      />
    </div>
  );
}
